(ns ncr.manage.ai-assist
  (:require
   [uix.core.alpha :as uix]
   [ncr.me :as me]
   [ncr.widgets.core :as w]
   [ncr.etc.pf :as pf]
   [ncr.etc.rhf :as rhf]
   [ncr.widgets.pf :as wpf]
   [ncr.amplitude :as amp]
   [ncr.etc.alert :as a]
   [ncr.etc.profile :as p]
   [ncr.navigate :as n]
   [ncr.manage.folders :as folders]))

(defn- c-toolbar []
  [pf/c-toolbar
   [pf/c-toolbar-content
    [pf/c-toolbar-group {:variant :icon-button-group}
     [w/c-toolbar-button
      {:icon :arrow-left
       :on-click
       (fn [_]
         #_(amp/navigate! {"Origin" "Manage AI Assist" "Destination" "<back>"})
         (n/back!))
       :tooltip "Back"}]]]])

(def ^:private pspec
  [:remote-cluster "ai-assist/settings"])

(def ^:private default-settings
  {:enabled false
   :auto {:users #{} :folders #{}}
   :label "$none"
   :prompt ""})

(defn- c-settings [{:keys [form]}]
  (let
    [{:keys [get-values]} form

     labels
     (sort-by :name
       (get-in (uix/context me/*context*) [:cluster :labels]))

     disabled (not (.-enabled (get-values)))

     {:keys [register register-pf]} form]
    [:<>
     [rhf/c-form-group {:label "Mark w/ Label"} :label form
      [:select.pf-c-form-control
       (merge
         (register :label)
         {:aria-label :label
          :disabled disabled})
       (for [{lname :name id :id}
             (into [{:name "(don't mark)" :id "$none"}] labels)] 
         [pf/c-form-select-option
          {:key (str "id" id)
           :value id
           :label (cond->> lname (not= id "$none") (str "#"))}])]]
     [rhf/c-form-group {:label "Custom Prompt"} :prompt form
      [pf/c-text-area
       (merge
         (register-pf :prompt)
         {:rows 10
          :is-disabled disabled})]]]))

(defn- c-auto-accept [{:keys [form users folders]}]
  (let [{:keys [get-values]} form
        disabled (not (.-enabled (get-values)))]
    [:div
     [:div.pf-u-mb-lg
      "Automatically accept documents if they are in the Inbox folder of:"]
     [pf/c-data-list {:is-compact true}
      (for [{:keys [id email] uname :name} users
            :let [k (str "auto[users][" id "]")]]
        [pf/c-data-list-item {:key id}
         [pf/c-data-list-item-row
          [pf/c-data-list-item-cells {:width 1}
           [pf/c-data-list-cell
            [:label
             [wpf/c-pf-checkbox
              {:is-disabled disabled :name k :form form :class :pf-u-mr-lg}]
             uname " " [:small email]]]]]])]

     [:div.pf-u-m-lg
      "...or in a shared folder named:"]
     [pf/c-data-list {:is-compact true}
      (for [{:keys [id] fname :name} folders
            :let [k (str "auto[folders][" id "]")]]
        [pf/c-data-list-item {:key id}
         [pf/c-data-list-item-row
          [pf/c-data-list-item-cells {:width 1}
           [pf/c-data-list-cell
            [:label
             [wpf/c-pf-checkbox {:name k :form form :class :pf-u-mr-lg}]
             fname]]]]])]]))

(defn- set->map [s lst]
  (into {}
    (for [{:keys [id]} lst]
      [id (contains? s id)])))

(defn- map->set [m lst]
  (set
    (for [{:keys [id]} lst
          :when (m (keyword id))]
      id)))

(defn- data->form [{:keys [data users folders]}]
  (-> data
    (update-in [:auto :users] set->map users)
    (update-in [:auto :folders] set->map folders)))

(defn- form->data [{:keys [data users folders]}]
  (-> data
    (update-in [:auto :users] map->set users)
    (update-in [:auto :folders] map->set folders)))

(defn- c-form [{:keys [data folders users] :as props}]
  (let [{:keys [handle-submit form-state reset] :as form}
        (rhf/use-form
          {:shouldFocusError false :default-values (data->form props)})

        props (assoc props :form form)]
    [pf/c-form
     {:class :pf-u-mt-lg
      :on-submit
      (handle-submit
        (fn [data e]
          (let [data (form->data (assoc props :data data))]
            (.preventDefault e)
            #_(js/alert (pr-str data))
            (a/!operation
              {:operation-title "Updating Settings"
               :success-title "Settings Updated"}
              (p/write-profile! pspec data))
            (reset data {:keepValues true}))))}
     [rhf/c-form-group :enabled form
      [wpf/c-pf-checkbox
       {:name :enabled :form form :label "Enable AI Assist"}]]
     [pf/c-tabs {:default-active-key :main}
      [pf/c-tab
       {:title [pf/c-tab-title-text "Settings"]
        :event-key :main}
       [c-settings props]]
      [pf/c-tab
       {:title [pf/c-tab-title-text "Auto-accept"]
        :event-key :accept}
       [c-auto-accept props]]]
     [pf/c-action-group
      [pf/c-button
       {:variant :primary
        :type :submit
        :is-disabled (not (:is-dirty form-state))}
       "Save Settings"]]]))

(defn c-page []
  (let [data (p/use-profile pspec default-settings)

        users
        (sort-by :name (get-in (uix/context me/*context*) [:cluster :users]))
        
        {f-status :status f-items :items} @(folders/use-folders)

        folders
        (->> f-items
          (filter #(= (:folderType %) "SHARED"))
          (sort-by :name))]
    [:<>
     [pf/c-page-section
      {:class :pf-u-p-0
       :variant :light
       :sticky :top
       :aria-label "Toolbar"}
      [c-toolbar]]

     [pf/c-page-section
      {:class :pf-u-p-0
       :variant :default
       :has-overflow-scroll true
       :is-filled true
       :aria-label "AI Assist"}
      [pf/c-panel {:class :ncr-u-border-bottom}
       [pf/c-panel-header {:class-name :pf-u-font-size-xl}
        "AI Assist Settings"]
       [pf/c-panel-main
         [pf/c-panel-main-body
          (when (and @data (= f-status :loaded))
            [c-form {:data @data :users users :folders folders}])]]]]]))
